import React, { useState } from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableFooter,
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableHeadStyled,
  Row
} from 'components'
import { DeleteIcon, ViewFileIcon } from 'components/Icons'
import { useFile, useModal } from 'hooks'
import { IDocsItems } from 'services/NGT/DjurServices'
import { FORMAT, SPACING } from 'utils'

interface ITableDocuments {
  tableData: IDocsItems[]
  handleDeleteDjurDocument?: (_djur: IDocsItems) => void
  isConsult?: boolean
}

const TableDjurDocuments: React.FC<ITableDocuments> = ({
  tableData,
  handleDeleteDjurDocument: handleDeleteDjurDocument,
  isConsult
}) => {
  const { viewFile } = useFile()
  const { showModal } = useModal()

  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled>Tipo Documento</TableCellStyled>
              <TableCellStyled>Competência</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(tableData?.length > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            )?.map((row, index) => (
              <TableRowStyled key={`${index}${row.contrato}`}>
                <TableCellStyled>{row.contrato}</TableCellStyled>
                <TableCellStyled>{row.txDescricaoPendencia}</TableCellStyled>
                <TableCellStyled align="center">
                  {FORMAT.competencia(row.competencia)}
                </TableCellStyled>
                <TableCellStyled align="center" minwidth="90px">
                  <Row justifyContent="center" alignItems="center">
                    <ViewFileIcon
                      onClick={() =>
                        viewFile({
                          gedExternalID: row.idDocumentoGed,
                          local: {
                            base64: row.file,
                            filename: row.txFileName
                          }
                        })
                      }
                      cursor="pointer"
                    />
                    {!isConsult && (
                      <DeleteIcon
                        marginLeft={SPACING.spacing15}
                        onClick={() =>
                          showModal({
                            handleConfirm: () => handleDeleteDjurDocument(row),
                            message: `Tem certeza de que deseja deletar o tipo de documento: ${row.txDescricaoPendencia}`,
                            txtButtonCancel: 'Não',
                            txtButtonConfirm: 'Sim',
                            type: 'alert'
                          })
                        }
                        cursor="pointer"
                      />
                    )}
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}

export default TableDjurDocuments
